import Cookies from 'js-cookie';

// Initialize an agent at application startup.
const fingerprintCookieName = 'apolloFP';

if (Cookies.get(fingerprintCookieName) === undefined) {
  import('@fingerprintjs/fingerprintjs').then((FingerprintJS) => {
    FingerprintJS.load({ monitoring: false })
      .then((fp) => fp.get())
      .then((result) => {
        // Exclude plugins as their order and contents seems unstable within chrome:
        // Issue: https://github.com/fingerprintjs/fingerprintjs/issues/794
        // eslint-disable-next-line no-unused-vars
        const { plugins, ...components } = result.components;
        Cookies.set(fingerprintCookieName, FingerprintJS.hashComponents(components));
      });
  });
}
